import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import reviewImage1 from '../assets/images/review1.jpg';
import reviewImage2 from '../assets/images/review2.jpg';

const LandingPage = () => {
  const [currentImage, setCurrentImage] = useState(reviewImage1);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => prev === reviewImage1 ? reviewImage2 : reviewImage1);
    }, 4000); // Switch every 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="landing-page" style={{ backgroundImage: `url(${currentImage})` }}>
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="title">TAHIR PALALI - O</h1>
          
          <div className="main-content">
            <div className="album-info">
              <p className="album-status">Album Available Now!</p>
              <Link to="/album-preview" className="hear-music-btn">HEAR THE MUSIC</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;